<div class="account-sheet">
  <span class="sheet-grab" aria-hidden="true"></span>

  <div class="sheet-who">
    <span class="sheet-avatar" aria-hidden="true">{{ initials() }}</span>
    <div class="sheet-identity">
      <span class="sheet-name">{{ fullname() }}</span>
      <span class="role-chip">{{ roleKey() | translate }}</span>
    </div>
  </div>

  @if (shortcuts().length > 0) {
  <h2 class="sheet-section">{{ 'account.sections.go-to' | translate }}</h2>
  <app-account-menu-card [rows]="shortcuts()" (rowSelected)="onRowSelected($event)" />
  <h2 class="sheet-section">{{ 'account.sections.account' | translate }}</h2>
  }
  <app-account-menu-card [rows]="accountRows()" (rowSelected)="onRowSelected($event)" />

  <p class="sheet-version">{{ 'account.version' | translate: { version } }}</p>
</div>
